import { cloudinary } from '@trmediaab/zebra-utils';
import { rgba } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ErrorBoundary from '~/components/ErrorBoundary';
import { betTypeColors } from '~/utils/css-mixins';
import { formatDate } from '~/utils/format';

const Root = styled.div`
  padding-bottom: 1.5rem;
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
`;

const ImageLabel = styled.div`
  position: absolute;
  bottom: 7px;
  left: 15px;
  color: white;
  min-width: 50%;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 3px;
  ${props => `background-color: ${rgba(betTypeColors(props.bet_type).to, 0.7)}`}
`;

const Image = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: #f3f1ef;
  background-image: ${props =>
    props.imageId
      ? `url('${cloudinary.getUrl(props.imageId, 545)}')`
      : undefined};
  background-size: cover;
  background-position: top center;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2308;
  margin: 1rem 1rem 0;
`;

const AuthorTitle = styled(Title).attrs({ as: 'h3' })`
  font-weight: normal;

  & + ${Title} {
    margin-top: 0.5rem;
  }
`;

const ListItemContent = ({
  showAuthor,
  data: {
    authors: [author],
    image,
    headline,
    round,
  },
}) => {
  let selectedImage, authorTitle, heading;

  if (showAuthor && author != null) {
    selectedImage = author.image2;
    authorTitle = (
      <AuthorTitle>
        {author.firstname} {author.lastname}
      </AuthorTitle>
    );
    heading = `"${headline}"`;
  } else {
    selectedImage = image;
    heading = headline;
  }

  return (
    <ErrorBoundary>
      <Root>
        <ImageWrapper>
          <Image
            imageId={selectedImage != null ? selectedImage.image_id : undefined}
          />

          {round && (
            <ImageLabel bet_type={round.bet_type}>
              {round.bet_type} {round.track_name}{' '}
              {formatDate(new Date(round.round_date), 'dd/MM')}
            </ImageLabel>
          )}
        </ImageWrapper>

        {authorTitle}
        <Title>{heading}</Title>
      </Root>
    </ErrorBoundary>
  );
};

ListItemContent.propTypes = {
  showAuthor: PropTypes.bool,
  data: PropTypes.shape({
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.object,
        firstname: PropTypes.string.isRequired,
        lastname: PropTypes.string.isRequired,
      }),
    ),
    image: PropTypes.object,
    headline: PropTypes.string.isRequired,
  }),
};

export default ListItemContent;
